/** 活动 Banner / 弹窗展示位置（一点 PPT） */
export const ACTIVITY_LOCATION = {
  HOME: 'HOME',
  TEMPLATE: 'TEMPLATE',
  MEMBER: 'MEMBER',
  WORKS: 'WORKS',
  MINE: 'MINE',
} as const

export type ActivityLocation = (typeof ACTIVITY_LOCATION)[keyof typeof ACTIVITY_LOCATION]

const LEGACY_LOCATION_MAP: Record<string, ActivityLocation> = {
  HOME: ACTIVITY_LOCATION.HOME,
  TEMPLATE: ACTIVITY_LOCATION.TEMPLATE,
  MEMBER: ACTIVITY_LOCATION.MEMBER,
  WORKS: ACTIVITY_LOCATION.WORKS,
  MINE: ACTIVITY_LOCATION.MINE,
  // 公文宝旧值兼容
  VIP: ACTIVITY_LOCATION.MEMBER,
}

export const normalizeActivityLocation = (location?: unknown): ActivityLocation => {
  const raw = Array.isArray(location) ? location[0] : location
  if (typeof raw !== 'string' || !raw.trim()) return ACTIVITY_LOCATION.HOME
  const key = raw.trim().toUpperCase()
  return LEGACY_LOCATION_MAP[key] || ACTIVITY_LOCATION.HOME
}

export const getActivityPageNamePrefix = (location?: unknown) => {
  const loc = normalizeActivityLocation(location)
  if (loc === ACTIVITY_LOCATION.MINE) return '我的页_活动弹窗_'
  if (loc === ACTIVITY_LOCATION.MEMBER) return '会员页_活动弹窗_'
  if (loc === ACTIVITY_LOCATION.TEMPLATE) return '模板页_活动弹窗_'
  if (loc === ACTIVITY_LOCATION.WORKS) return '作品页_活动弹窗_'
  return '首页_活动弹窗_'
}
